import DeletePopup from "components/popups/DeletePopup";
import React from "react";
import AccessoryGroupPopup from "./AccessoryGroupPopup";
import AnnexPopup from "./AnnexPopup";
import DiscountManagementPopup from "./DiscountManagementPopup.tsx";
import AccessoryEditPopup from "./AccessoryEditPopup.tsx";
import AccessorySuperEditPopup from "./AccessorySuperEditPopup";
import FaqPopup from "./FaqPopup";
import HpEditPopup from "./HpEditPopup";
import HpSuperEditPopup from "./HpSuperEditPopup";
import ParameterPopup from "./ParameterPopup";
import EnergyPopup from "./EnergyPopup";
import LocalePopup from "./LocalePopup";
import EnvironmentPopup from "./EnvironmentPopup";
import AdminUserPopup from "./AdminUserPopup";
import ChangelogPopup from "./ChangelogPopup";
import SatisfactionViewPopup from "./SatisfactionViewPopup";
import TvaPopup, { type DatasourceMutationRequest } from "./TvaPopup";
import YearLossPopup from "./YearLossPopup";
import TutorialEditPopup from "./TutorialEditPopup";

type TableRecord = Record<string, any>;

type GridSpecialPopupsProps = {
  deletingRow: TableRecord | null;
  onCloseDelete: () => void;
  onConfirmDelete: () => void;

  isTvaCreateOpen: boolean;
  setIsTvaCreateOpen: (open: boolean) => void;
  editingRow: TableRecord | null;
  setEditingRow: (row: TableRecord | null) => void;

  isEnergyEditOpen: boolean;
  setIsEnergyEditOpen: (open: boolean) => void;
  editingEnergyRow: TableRecord | null;
  setEditingEnergyRow: (row: TableRecord | null) => void;
  isEnergySuperTable: boolean;

  isLocaleEditOpen: boolean;
  setIsLocaleEditOpen: (open: boolean) => void;
  editingLocaleRow: TableRecord | null;
  setEditingLocaleRow: (row: TableRecord | null) => void;

  isEnvironmentEditOpen: boolean;
  setIsEnvironmentEditOpen: (open: boolean) => void;
  editingEnvironmentRow: TableRecord | null;
  setEditingEnvironmentRow: (row: TableRecord | null) => void;

  isAdminUsersEditOpen: boolean;
  setIsAdminUsersEditOpen: (open: boolean) => void;
  editingAdminUsersRow: TableRecord | null;
  setEditingAdminUsersRow: (row: TableRecord | null) => void;

  isAccessoryGroupEditOpen: boolean;
  setIsAccessoryGroupEditOpen: (open: boolean) => void;
  editingAccessoryGroupRow: TableRecord | null;
  setEditingAccessoryGroupRow: (row: TableRecord | null) => void;

  isYearLossEditOpen: boolean;
  setIsYearLossEditOpen: (open: boolean) => void;
  editingYearLossRow: TableRecord | null;
  setEditingYearLossRow: (row: TableRecord | null) => void;

  isAnnexEditOpen: boolean;
  setIsAnnexEditOpen: (open: boolean) => void;
  editingAnnexRow: TableRecord | null;
  setEditingAnnexRow: (row: TableRecord | null) => void;

  isFaqEditOpen: boolean;
  setIsFaqEditOpen: (open: boolean) => void;
  editingFaqRow: TableRecord | null;
  setEditingFaqRow: (row: TableRecord | null) => void;

  isVersionEditOpen: boolean;
  setIsVersionEditOpen: (open: boolean) => void;
  editingVersionRow: TableRecord | null;
  setEditingVersionRow: (row: TableRecord | null) => void;

  isSatisfactionViewOpen: boolean;
  setIsSatisfactionViewOpen: (open: boolean) => void;
  viewingSatisfactionRow: TableRecord | null;
  setViewingSatisfactionRow: (row: TableRecord | null) => void;

  isParameterEditOpen: boolean;
  setIsParameterEditOpen: (open: boolean) => void;
  editingParameterRow: TableRecord | null;
  setEditingParameterRow: (row: TableRecord | null) => void;

  isDiscountManagementEditOpen: boolean;
  setIsDiscountManagementEditOpen: (open: boolean) => void;
  editingDiscountManagementRow: TableRecord | null;
  setEditingDiscountManagementRow: (row: TableRecord | null) => void;

  isAccessoryEditOpen: boolean;
  setIsAccessoryEditOpen: (open: boolean) => void;
  editingAccessoryRow: TableRecord | null;
  setEditingAccessoryRow: (row: TableRecord | null) => void;

  isAccessorySuperEditOpen: boolean;
  setIsAccessorySuperEditOpen: (open: boolean) => void;
  editingAccessorySuperRow: TableRecord | null;
  setEditingAccessorySuperRow: (row: TableRecord | null) => void;

  isHpSuperEditOpen: boolean;
  setIsHpSuperEditOpen: (open: boolean) => void;
  editingHpSuperRow: TableRecord | null;
  setEditingHpSuperRow: (row: TableRecord | null) => void;

  isHpEditOpen: boolean;
  setIsHpEditOpen: (open: boolean) => void;
  editingHpRow: TableRecord | null;
  setEditingHpRow: (row: TableRecord | null) => void;

  isTutorialEditOpen: boolean;
  setIsTutorialEditOpen: (open: boolean) => void;
  editingTutorialRow: TableRecord | null;
  setEditingTutorialRow: (row: TableRecord | null) => void;
  isAdminTutorialsLayout: boolean;

  createDatasourceRequest: DatasourceMutationRequest | null;
  updateDatasourceRequest: DatasourceMutationRequest | null;
  envNumeric: number | undefined;
  lang: string;
  refetchDatasource: () => Promise<any>;
  refetchFaq?: () => void;
  refetchAdminUsers?: () => Promise<any>;
  refetchVersions?: () => void;
};

const GridSpecialPopups = ({
  deletingRow,
  onCloseDelete,
  onConfirmDelete,
  isTvaCreateOpen,
  setIsTvaCreateOpen,
  editingRow,
  setEditingRow,
  isEnergyEditOpen,
  setIsEnergyEditOpen,
  editingEnergyRow,
  setEditingEnergyRow,
  isEnergySuperTable,
  isLocaleEditOpen,
  setIsLocaleEditOpen,
  editingLocaleRow,
  setEditingLocaleRow,
  isEnvironmentEditOpen,
  setIsEnvironmentEditOpen,
  editingEnvironmentRow,
  setEditingEnvironmentRow,
  isAdminUsersEditOpen,
  setIsAdminUsersEditOpen,
  editingAdminUsersRow,
  setEditingAdminUsersRow,
  isAccessoryGroupEditOpen,
  setIsAccessoryGroupEditOpen,
  editingAccessoryGroupRow,
  setEditingAccessoryGroupRow,
  isYearLossEditOpen,
  setIsYearLossEditOpen,
  editingYearLossRow,
  setEditingYearLossRow,
  isAnnexEditOpen,
  setIsAnnexEditOpen,
  editingAnnexRow,
  setEditingAnnexRow,
  isFaqEditOpen,
  setIsFaqEditOpen,
  editingFaqRow,
  setEditingFaqRow,
  isVersionEditOpen,
  setIsVersionEditOpen,
  editingVersionRow,
  setEditingVersionRow,
  isSatisfactionViewOpen,
  setIsSatisfactionViewOpen,
  viewingSatisfactionRow,
  setViewingSatisfactionRow,
  isParameterEditOpen,
  setIsParameterEditOpen,
  editingParameterRow,
  setEditingParameterRow,
  isDiscountManagementEditOpen,
  setIsDiscountManagementEditOpen,
  editingDiscountManagementRow,
  setEditingDiscountManagementRow,
  isAccessoryEditOpen,
  setIsAccessoryEditOpen,
  editingAccessoryRow,
  setEditingAccessoryRow,
  isAccessorySuperEditOpen,
  setIsAccessorySuperEditOpen,
  editingAccessorySuperRow,
  setEditingAccessorySuperRow,
  isHpSuperEditOpen,
  setIsHpSuperEditOpen,
  editingHpSuperRow,
  setEditingHpSuperRow,
  isHpEditOpen,
  setIsHpEditOpen,
  editingHpRow,
  setEditingHpRow,
  isTutorialEditOpen,
  setIsTutorialEditOpen,
  editingTutorialRow,
  setEditingTutorialRow,
  isAdminTutorialsLayout,
  createDatasourceRequest,
  updateDatasourceRequest,
  envNumeric,
  lang,
  refetchDatasource,
  refetchFaq,
  refetchAdminUsers,
  refetchVersions,
}: GridSpecialPopupsProps) => {
  const isEnergySuperContext =
    isEnergySuperTable ||
    /energy[_\s-]*mgt|energies[_\s-]*mgt/i.test(createDatasourceRequest?.url ?? "") ||
    /energy[_\s-]*mgt|energies[_\s-]*mgt/i.test(updateDatasourceRequest?.url ?? "");
  const faqRequest = editingFaqRow ? updateDatasourceRequest : (createDatasourceRequest ?? updateDatasourceRequest);
  const faqMode = editingFaqRow ? "edit" : "create";
  const versionRequest = editingVersionRow ? updateDatasourceRequest : (createDatasourceRequest ?? updateDatasourceRequest);
  const versionMode = editingVersionRow ? "edit" : "create";

  return (
    <>
      <DeletePopup
        isOpen={deletingRow != null}
        closePopup={onCloseDelete}
        onDelete={onConfirmDelete}
        message="Are you sure you want to delete?"
      />

      <TvaPopup
        isOpen={isTvaCreateOpen}
        onClose={() => {
          setIsTvaCreateOpen(false);
          setEditingRow(null);
        }}
        request={updateDatasourceRequest}
        envNumeric={envNumeric}
        mode={editingRow ? "edit" : "create"}
        row={editingRow}
        onSaved={async () => {
          setEditingRow(null);
          await refetchDatasource();
        }}
      />

      <EnergyPopup
        isOpen={isEnergyEditOpen}
        onClose={() => {
          setIsEnergyEditOpen(false);
          setEditingEnergyRow(null);
        }}
        request={editingEnergyRow ? updateDatasourceRequest : (createDatasourceRequest ?? updateDatasourceRequest)}
        isSuperContext={isEnergySuperContext}
        envNumeric={envNumeric}
        lang={lang}
        row={editingEnergyRow}
        onSaved={async () => {
          setEditingEnergyRow(null);
          await refetchDatasource();
        }}
      />

      <LocalePopup
        isOpen={isLocaleEditOpen}
        onClose={() => {
          setIsLocaleEditOpen(false);
          setEditingLocaleRow(null);
        }}
        request={updateDatasourceRequest}
        lang={lang}
        mode={editingLocaleRow ? "edit" : "create"}
        row={editingLocaleRow}
        onSaved={async () => {
          setEditingLocaleRow(null);
          await refetchDatasource();
        }}
      />

      <EnvironmentPopup
        isOpen={isEnvironmentEditOpen}
        onClose={() => {
          setIsEnvironmentEditOpen(false);
          setEditingEnvironmentRow(null);
        }}
        request={editingEnvironmentRow ? updateDatasourceRequest : (createDatasourceRequest ?? updateDatasourceRequest)}
        envNumeric={envNumeric}
        lang={lang}
        mode={editingEnvironmentRow ? "edit" : "create"}
        row={editingEnvironmentRow}
        onSaved={async () => {
          setEditingEnvironmentRow(null);
        }}
      />

      <AdminUserPopup
        isOpen={isAdminUsersEditOpen}
        onClose={() => {
          setIsAdminUsersEditOpen(false);
          setEditingAdminUsersRow(null);
        }}
        mode={editingAdminUsersRow ? "edit" : "create"}
        row={editingAdminUsersRow}
        onSaved={async () => {
          setEditingAdminUsersRow(null);
          if (refetchAdminUsers) {
            await refetchAdminUsers();
          }
          await refetchDatasource();
        }}
      />

      <AccessoryGroupPopup
        isOpen={isAccessoryGroupEditOpen}
        onClose={() => {
          setIsAccessoryGroupEditOpen(false);
          setEditingAccessoryGroupRow(null);
        }}
        request={updateDatasourceRequest}
        lang={lang}
        mode={editingAccessoryGroupRow ? "edit" : "create"}
        row={editingAccessoryGroupRow}
        onSaved={async () => {
          setEditingAccessoryGroupRow(null);
          await refetchDatasource();
        }}
      />

      <YearLossPopup
        isOpen={isYearLossEditOpen}
        onClose={() => {
          setIsYearLossEditOpen(false);
          setEditingYearLossRow(null);
        }}
        request={updateDatasourceRequest}
        envNumeric={envNumeric}
        row={editingYearLossRow}
        onSaved={async () => {
          setEditingYearLossRow(null);
          await refetchDatasource();
        }}
      />

      <AnnexPopup
        isOpen={isAnnexEditOpen}
        onClose={() => {
          setIsAnnexEditOpen(false);
          setEditingAnnexRow(null);
        }}
        request={updateDatasourceRequest}
        envNumeric={envNumeric}
        mode={editingAnnexRow ? "edit" : "create"}
        row={editingAnnexRow}
        onSaved={async () => {
          setEditingAnnexRow(null);
          await refetchDatasource();
        }}
      />

      <FaqPopup
        isOpen={isFaqEditOpen}
        onClose={() => {
          setIsFaqEditOpen(false);
          setEditingFaqRow(null);
        }}
        request={faqRequest}
        mode={faqMode}
        row={editingFaqRow}
        onSaved={async () => {
          setEditingFaqRow(null);
          refetchFaq?.();
          await refetchDatasource();
        }}
      />

      <ChangelogPopup
        isOpen={isVersionEditOpen}
        onClose={() => {
          setIsVersionEditOpen(false);
          setEditingVersionRow(null);
        }}
        request={versionRequest}
        mode={versionMode}
        row={editingVersionRow}
        onSaved={async () => {
          setEditingVersionRow(null);
          refetchVersions?.();
          await refetchDatasource();
        }}
      />

      <SatisfactionViewPopup
        isOpen={isSatisfactionViewOpen}
        onClose={() => {
          setIsSatisfactionViewOpen(false);
          setViewingSatisfactionRow(null);
        }}
        row={viewingSatisfactionRow}
      />

      <ParameterPopup
        isOpen={isParameterEditOpen}
        onClose={() => {
          setIsParameterEditOpen(false);
          setEditingParameterRow(null);
        }}
        request={updateDatasourceRequest}
        envNumeric={envNumeric}
        mode={editingParameterRow ? "edit" : "create"}
        row={editingParameterRow}
        onSaved={async () => {
          setEditingParameterRow(null);
          await refetchDatasource();
        }}
      />

      <DiscountManagementPopup
        isOpen={isDiscountManagementEditOpen}
        onClose={() => {
          setIsDiscountManagementEditOpen(false);
          setEditingDiscountManagementRow(null);
        }}
        request={updateDatasourceRequest}
        envNumeric={envNumeric}
        mode={editingDiscountManagementRow ? "edit" : "create"}
        row={editingDiscountManagementRow}
        onSaved={async () => {
          setEditingDiscountManagementRow(null);
          await refetchDatasource();
        }}
      />

      <AccessoryEditPopup
        isOpen={isAccessoryEditOpen}
        onClose={() => {
          setIsAccessoryEditOpen(false);
          setEditingAccessoryRow(null);
        }}
        request={updateDatasourceRequest}
        envNumeric={envNumeric}
        lang={lang}
        row={editingAccessoryRow}
        onSaved={async () => {
          setEditingAccessoryRow(null);
          await refetchDatasource();
        }}
      />

      <AccessorySuperEditPopup
        isOpen={isAccessorySuperEditOpen}
        onClose={() => {
          setIsAccessorySuperEditOpen(false);
          setEditingAccessorySuperRow(null);
        }}
        request={editingAccessorySuperRow ? updateDatasourceRequest : (createDatasourceRequest ?? updateDatasourceRequest)}
        mode={editingAccessorySuperRow ? "edit" : "create"}
        row={editingAccessorySuperRow}
        envNumeric={envNumeric}
        lang={lang}
        onSaved={async () => {
          setEditingAccessorySuperRow(null);
          await refetchDatasource();
        }}
      />

      <HpSuperEditPopup
        isOpen={isHpSuperEditOpen}
        onClose={() => {
          setIsHpSuperEditOpen(false);
          setEditingHpSuperRow(null);
        }}
        request={editingHpSuperRow ? updateDatasourceRequest : (createDatasourceRequest ?? updateDatasourceRequest)}
        mode={editingHpSuperRow ? "edit" : "create"}
        row={editingHpSuperRow}
        envNumeric={envNumeric}
        lang={lang}
        onSaved={async () => {
          setEditingHpSuperRow(null);
          await refetchDatasource();
        }}
      />

      <HpEditPopup
        isOpen={isHpEditOpen}
        onClose={() => {
          setIsHpEditOpen(false);
          setEditingHpRow(null);
        }}
        request={updateDatasourceRequest}
        row={editingHpRow}
        envNumeric={envNumeric}
        lang={lang}
        onSaved={async () => {
          setEditingHpRow(null);
          await refetchDatasource();
        }}
      />

      <TutorialEditPopup
        isOpen={isTutorialEditOpen}
        onClose={() => {
          setIsTutorialEditOpen(false);
          setEditingTutorialRow(null);
        }}
        mode={editingTutorialRow ? "edit" : "create"}
        row={editingTutorialRow}
        envNumeric={envNumeric}
        lang={lang}
        isAdminTutorial={isAdminTutorialsLayout}
        onSaved={async () => {
          setEditingTutorialRow(null);
          try {
            await refetchDatasource();
          } catch {
            // Tutorials/admin tutorials can be driven by dedicated queries; skip refetch errors safely.
          }
        }}
      />
    </>
  );
};

export default GridSpecialPopups;
